/* eslint-disable jsx-a11y/label-has-for */
import React, { useState, useEffect } from 'react';
// import { PropTypes } from 'prop-types';

const SocialLogosContainer = ({
  activeLanguage,
  handlerSetComponents,
  components,
  languages,
  id,
  reusableComponent,
  reusableComponentSlugname,
}) => {
  const initialState = {
    type: 'SocialLogosContainer',
    logos: [],
  };

  const [index, setIndex] = useState();
  const [state, setState] = useState(initialState);

  // const [showOptions, setShowOptions] = useState(false);

  const [logos, setLogos] = useState([]);

  // useEffect(() => {
  //   if (slider) {
  //     setColorWhite(true);
  //     const comp = {
  //       ...state,
  //       color: 'white',
  //     };
  //     setState(comp);
  //   } else {
  //     setColorWhite(false);
  //     const comp = {
  //       ...state,
  //       color: 'black',
  //     };
  //     setState(comp);
  //   }
  // }, []);

  // const inputHandler = (e) => {
  //   const { value, name, lang } = e.target;

  //   const { component } = components[index];

  //   const comp = {
  //     ...component,
  //     [name]: {
  //       ...component[name],
  //       [lang.toLowerCase()]: value,
  //     },
  //   };

  //   setState(comp);

  //   const componentObj = {
  //     id,
  //     component: comp,
  //   };

  //   handlerSetComponents(componentObj, index);
  // };

  // const setChangeColor = () => {
  //   setColorWhite(!isColorWhite);

  //   if (index >= 0 && components.length) {
  //     const { component } = components[index];
  //     const borderColor = !isColorWhite ? 'white' : 'black';

  //     const comp = {
  //       ...component,
  //       color: borderColor,
  //     };
  //     setState(comp);

  //     const componentObj = {
  //       id,
  //       component: comp,
  //     };

  //     handlerSetComponents(componentObj, index);
  //   }
  // };

  // useEffect(() => {
  //   if (index >= 0 && components.length) {
  //     const { component } = components[index];
  //     const borderColor = isColorWhite ? 'white' : 'black';

  //     const comp = {
  //       ...component,
  //       color: borderColor,
  //     };
  //     setState(comp);

  //     const componentObj = {
  //       id,
  //       component: comp,
  //     };

  //     handlerSetComponents(componentObj, index);
  //   }
  // }, [isColorWhite]);

  useEffect(() => {
    const componentIndex = components.findIndex(obj => obj.id === id);
    const { component } = components[componentIndex];
    if (reusableComponent) {
      setState(reusableComponent);
      if (!component) handlerSetComponents({ component: { key: reusableComponentSlugname } }, componentIndex);
    } else {
      setIndex(componentIndex);
      if (component) {

        const {
          logos: currentLogos,
        } = component;

        setLogos(currentLogos);

      } else {
        const componentObj = {
          id,
          component: state,
        };

        handlerSetComponents(componentObj, componentIndex);
      }
    }
  }, [components]);

  useEffect(() => {
    const componentIndex = components.findIndex(obj => obj.id === id);
    const construction = {
      type: state.type,
      compId: state.compId || '',
      logos,
    }
    handlerSetComponents({ component: construction }, componentIndex);
  }, [
    logos,
  ]);

  // Each of these builds a new array/object rather than mutating in place: the
  // effect above is keyed on `logos`, so writing back the same reference makes
  // React bail out and the edit never reaches the saved component. The old
  // truthiness guard also skipped writes whenever the current value was an
  // empty string, which made a freshly added row impossible to fill in.
  const titleChange = (e) => {
    const itemIndex = e.target.getAttribute('itemindex');
    const { name, value } = e.target;
    if (!logos || !logos[itemIndex]) return;

    setLogos(logos.map((logo, i) => (
      String(i) === String(itemIndex) ? { ...logo, [name]: value } : logo
    )));
  }

  const addLogo = () => {
    setLogos([...(logos || []), { name: '', icon: '', link: '' }]);
  }

  const removeLogo = (itemIndex) => {
    setLogos((logos || []).filter((logo, i) => i !== itemIndex));
  }

  return (
    <div className="flex justify-start flex-col text-black">
      { logos && logos.map((item, index) => (
        <div
          key={`SocialLogosContainer_${index}`}
          className="flex flex-wrap py-4 border-b"
          >
          <div className="flex w-full justify-between items-center">
            <span className="uppercase tracking-wide text-xs font-bold">
              {item.name ? item.name : `Logo ${index + 1}`}
            </span>
            <div className="cursor-pointer p-2 rounded" onClick={() => removeLogo(index)}>
              <span className="font-icon icon-close-btn1" />
            </div>
          </div>
          <div className="w-full my-2">
            <label
              className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
              htmlFor="title-text-change">
              Name
                </label>
            <input
              className="appearance-none block
              bg-gray-200 text-gray-700 border border-red-500
              rounded py-3 px-4 w-full leading-tight focus:outline-none
              focus:bg-white"
              type="text"
              name="name"
              itemindex={index}
              // id="title-text-change"
              onChange={titleChange}
              value={item.name}
            />
          </div>
          <div className="w-full my-2">
            <label
              className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
              htmlFor="icon-text-change">
              Icon
                </label>
            <input
              className="appearance-none block
              bg-gray-200 text-gray-700 border border-red-500
              rounded py-3 px-4 w-full leading-tight focus:outline-none
              focus:bg-white"
              type="text"
              name="icon"
              itemindex={index}
              // id="icon-text-change"
              onChange={titleChange}
              value={item.icon}
            />
          </div>
          <div className="w-full my-2">
            <label
              className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
              htmlFor="link-text-change">
              Link
                </label>
            <input
              className="appearance-none block
              bg-gray-200 text-gray-700 border border-red-500
              rounded py-3 px-4 w-full leading-tight focus:outline-none
              focus:bg-white"
              type="text"
              name="link"
              itemindex={index}
              // id="link-text-change"
              onChange={titleChange}
              value={item.link}
            />
          </div>
        </div>
      ))}
      <div className="hover:bg-blue-light hover:text-white rounded w-full">
        <div
          className={`block appearance-none w-full
                bg-gray-200 border border-gray-200 text-gray-700 py-3 px-4 pr-8
                rounded leading-tight focus:outline-none focus:bg-white
                focus:border-gray-500 text-center`}
          onClick={addLogo}
        >+</div>
      </div>
      <p className="text-xs mt-2">
        Name picks the logo: it maps to the icon font glyph (facebook, twitter,
        instagram…) or, where there is no glyph, to a built-in SVG. TikTok is
        available as an SVG — use the name <strong>tiktok</strong>.
      </p>
    </div>
  );
};

// SocialLogosContainer.propTypes = {
//   activeLanguage: PropTypes.string.isRequired,
//   handlerSetComponents: PropTypes.func.isRequired,
//   components: PropTypes.arrayOf(PropTypes.shape()).isRequired,
//   id: PropTypes.string.isRequired,
//   languages: PropTypes.arrayOf(PropTypes.string).isRequired,
//   reusableComponent: PropTypes.shape(),
//   slider: PropTypes.bool,
// };
// SocialLogosContainer.defaultProps = {
//   reusableComponent: null,
//   slider: false,
// };

export default SocialLogosContainer;
